﻿import { IMilestoneBase, IProject } from "@/interfaces";

export const isValidProductCategory = (
  { canBeAdded }: IMilestoneBase,
  { productCategory }: IProject
): boolean => Array.isArray(canBeAdded) && canBeAdded.includes(productCategory);
